import CatalogAdmin from "@/app/admin/catalog/CatalogAdmin";

export default function SystemCatalogPage() {
  return <CatalogAdmin kind="tile" />;
}
